import { APIClient } from "render/context/APIContext";

export async function fetchPatientName(api: APIClient, externalId: string) {
  return api.patient
    .fetchPatient({ patientId: externalId })
    .result.then((details) => {
      if (details.name?.displayName) {
        return details.name.displayName;
      }
      for (const phyid of details.physicalIds) {
        if (phyid.startsWith("cur8:id:legacy:")) {
          return phyid.split(":")[3];
        }
      }
      return null;
    });
}
